<template>
  <div class="Exam">
    <el-button type="primary" @click="$router.go(-1)" class="go-back">← 返回</el-button>
    <div class="title">
      <p class="exam-name">{{ checkDetials.exam_name }}</p>
      <p>得分： {{ checkDetials.score }} 分</p>
      <p>
        试卷总分： {{ checkDetials.total_score }}分
      </p>
    </div>

    <div class="question-view" v-for="(item, index) in paperContent" :key="index">
      <!-- 题型 -->
      <div class="question-title">
        {{ index + 1 }}.[{{ quesTypeList[item.questionTypeCode] }}] ({{ item.score ? item.score : '0' }}
        分)
      </div>
      <div class="question-body">
        <!-- 题目内容 -->
        <p class="question-body-text">
          {{ item.content.title }}
          <el-image
            :src="item.content.titleImgUrl"
            alt="题目内容"
            class="content-img"
            v-if="item.content.titleImgUrl"
          ></el-image>
        </p>
        <!-- 题目选项-单选题 -->
        <el-radio-group
          :value="item.answer_sheet.answer"
          v-if="item.questionTypeCode === 'single-choice'">
          <el-radio disabled :label="ele.label" v-for="ele in item.options" :key="ele.label">
            {{ ele.label }}：{{ ele.value }}
            <el-image :src="ele.imageUrl" alt="题目选项" class="content-img" v-if="ele.imageUrl"></el-image>
          </el-radio>
        </el-radio-group>
        <!-- 题目选项-多选题 -->
        <el-checkbox-group
          :value="item.answer_sheet.answerLists"
          v-else-if="
              item.questionTypeCode === 'multiple-choice'
          "
        >
          <el-checkbox disabled :label="ele.label" v-for="ele in item.options" :key="ele.label">
            {{ ele.label }}：{{ ele.value }}
            <el-image :src="ele.imageUrl" alt="题目选项" class="content-img" v-if="ele.imageUrl"></el-image>
          </el-checkbox>
        </el-checkbox-group>
        <!-- 题目选项-判断题 -->
        <el-radio-group
          :value="item.answer_sheet.answer"
          disabled
          v-else-if="
            item.question_type_code === 'judgement' ||
              item.questionTypeCode === 'judgement'
          "
        >
          <el-radio label="true">正确</el-radio>
          <el-radio label="false">错误</el-radio>
        </el-radio-group>
        <!-- 题目选项-其他 -->
        <el-input
          type="textarea"
          :value="item.answer_sheet.answer"
          :autosize="{ minRows: 5 }"
          v-else
          disabled
        ></el-input>
        <div class="answer-box">
          <!-- 答案 -->
          <div class="answer-desc">
            <p>回答：{{ item.questionTypeCode === 'judgement' ? item.answer_sheet.answer === 'true' ? '正确' : '错误' : item.answer_sheet.answer }}</p>
            <p>阅卷意见：{{ item.answer_sheet.comment }}</p>
            <p>得分：{{ item.answer_sheet.score ? item.answer_sheet.score : 0 }}</p>
          </div>
          <!-- 正确答案 -->
          <div class="answer-desc">
            <p>正确答案：{{ item.questionTypeCode === 'judgement' ? item.answer === 'true' ? '正确' : '错误' : item.answer }}</p>
            <p>解析：{{ item.analysis }}</p>
          </div>
        </div>
      </div>
      <div class="question-right">
        <img src="@/assets/images/gou_icon.png" alt="" v-if="item.answer_sheet.right" />
        <img src="@/assets/images/cha_icon.png" alt="" v-else />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Exam",
  data() {
    return {
      multipleChoice: [],
      choiceType: "",
      choiceName: "",
      questionList: [],
      groupScoreShow: false,
      quesScore: "",
      scoreIndex: "",
      answer: [],

      checkDetials: {},
      paperContent: [],
      quesTypeList: {
        "single-choice": "单选题",
        "multiple-choice": "多选题",
        judgement: "判断题",
        "fill-in-the-blanks": "填空题",
        "simple-answer": "简答题",
        essay: "论述题",
        analysis: "分析题"
      }
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.userInfo)
    this.checkDetials = JSON.parse(sessionStorage.getItem('examDetail'))
    if (this.checkDetials.content) this.dealExamPaperQues();
  },
  methods: {
    dealExamPaperQues() {
      let content = JSON.parse(this.checkDetials.content)
      let answer_sheet = JSON.parse(this.checkDetials.answer_sheet)
      let paperAnswerSheet = []
      for (let key in content) {
        if (key === "multiple-choice" || key === "single-choice") {
          content[key].forEach(item => {
            let options = [];
            for (let j in item.content.choiceList) {
              let option = {
                label: j,
                value: item.content.choiceList[j],
                image: item.content.choiceImgList[j],
                imageUrl:
                  (item.content.choiceImgUrlList &&
                    item.content.choiceImgUrlList[j]) ||
                  (item.content.choiceImgList && item.content.choiceImgList[j])
              };
              options.push(option);
            }
            item.options = options;
          });
        }
        this.paperContent = [...this.paperContent, ...content[key]]
      }
      for (let key in answer_sheet) {
        if (key === "multiple-choice") {
          answer_sheet[key].forEach(item => {
            item.answerLists = item.answer.split(";");
          });
        }
        paperAnswerSheet = [...paperAnswerSheet, ...answer_sheet[key]]
      }
      for (let i = 0; i < this.paperContent.length; i++) {
        let row = paperAnswerSheet.find((ele) => ele.questionId === this.paperContent[i].id)
        if (row) {
          this.paperContent[i].answer_sheet = row
        }
      }
      console.log(this.paperContent)
    }
  }
};
</script>

<style lang="scss">
$themeColor: #4f8dfe;
.Exam {
  padding: 40px;
  .go-back {
    position: absolute;
    right: 50px;
  }
  .title {
    font-size: 16px;
    border-bottom: 1px solid rgb(206, 206, 206);
    margin-bottom: 20px;
    .exam-name {
      font-size: 18px;
      font-weight: bold;
    }
    p {
      span {
        cursor: pointer;
      }
      padding-bottom: 10px;
      .underline {
        text-decoration: underline;
      }
    }
  }
  .question-view {
    font-size: 14px;
    position: relative;
    .question-title {
      background: rgb(232, 239, 241);
      padding: 10px;
    }
    .question-body {
      padding: 10px 30px;
      .question-body-text {
        margin-bottom: 5px;
        line-height: 20px;
      }
      .el-radio-group,
      .el-checkbox-group,
      .el-textarea {
        padding: 10px 0 30px;
        .el-textarea__inner {
          line-height: 22px;
          color: #000;
          font-family: 'Avenir', Helvetica, Arial, sans-serif;
          letter-spacing: 0.5px;
        }
      }
      .answer-box {
        display: flex;
        justify-content: space-between;
        .answer-desc {
          flex: 1;
          margin-right: 30px;
        }
      }
      .answer-desc p {
        margin-bottom: 10px;
      }
      .content-img {
        margin-left: 8px;
        max-width: 375px;
      }
      .el-radio,
      .el-checkbox {
        display: block;
        margin-top: 6px;
      }
    }
    .question-right {
      position: absolute;
      right: 8px;
      top: 9px;
    }
  }
}
</style>
